var map = {
	"./1.png": "4198",
	"./2.png": "120c",
	"./3.png": "9f9c",
	"./4.png": "360e",
	"./5.png": "7d96",
	"./6.png": "bd24",
	"./7.png": "807e",
	"./8.png": "578a",
	"./9.png": "2d89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "29a5";